import { Modal } from 'antd';
import React from 'react';
import { ClientInvoiceSelectedType } from './ClientInvoiceSelect';
import CIList from '../pages/ClientInvoice/CIList';

export type ClientInvoiceSearchModalProps =  {
  visible: boolean;
  onCancel: () => void;
  setClientInvoice?: (
    clientInvoice: ClientInvoiceSelectedType
  ) => void;
  ctref?:string;
};

const ClientInvoiceSearchModal = ({
  ctref,
  onCancel,
  visible,
  setClientInvoice,
}: ClientInvoiceSearchModalProps) => {
  return (
    <Modal visible={visible} onCancel={onCancel} width={1200} destroyOnClose>
      <CIList
        onSelect={setClientInvoice}
        hideExtraAction
        hideCol
        ctreference={ctref}
      />
    </Modal>
  );
};

export default ClientInvoiceSearchModal;
